import { render, staticRenderFns } from "./CustomDrafts.vue?vue&type=template&id=f597b04e&"
import script from "./CustomDrafts.vue?vue&type=script&lang=js&"
export * from "./CustomDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f597b04e')) {
      api.createRecord('f597b04e', component.options)
    } else {
      api.reload('f597b04e', component.options)
    }
    module.hot.accept("./CustomDrafts.vue?vue&type=template&id=f597b04e&", function () {
      api.rerender('f597b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/CustomDrafts.vue"
export default component.exports